export default [
    {
        name: 'status',
        title: 'Type',
        titleClass: 'text-center',
        dataClass: 'text-center',
        width: '13%'
    },
    {
        name: 'date',
        title: 'Avant le',
        titleClass: 'text-center',
        dataClass: 'text-center',
        width: '13%'
    },
    {
        name: 'fullName',
        title: 'Nom',
        titleClass: 'text-center',
        dataClass: 'text-center',
        width: '14%'
    },
    {
        name: 'startDate',
        title: 'Date de début',
        titleClass: 'text-center',
        dataClass: 'text-center',
        width: '10%'
    },
    {
        name: 'expirationDate',
        title: 'Date de fin',
        titleClass: 'text-center',
        dataClass: 'text-center',
        width: '10%'
    },
    {
        name: 'employeeNumber',
        title: 'Matricule',
        titleClass: 'text-center',
        dataClass: 'text-center',
        width: '14%'
    },
    {
        name: 'reason',
        title: 'Motif',
        titleClass: 'text-center',
        dataClass: 'text-center',
    },
    {
        name: 'actions',
        title: 'Actions',
        titleClass: 'text-center',
        dataClass: 'text-center',
        width: '22%'
    }
];